import {MutationTree} from "vuex";
import * as moment from 'moment';
import Reward from "../../Redemptions/ts/Reward";
import RewardPartnerInterface from "../ts/RewardPartnerInterface";

export const mutations: MutationTree<any> = {

    setLoading(state: any, payload: boolean) {
        state.loading = payload;
    },

    setBrands(state: any, payload: Array<any>) {
        state.brands = [];
        state.brands = payload;
        state.expires = moment().add(24, 'hours');
    },

    bustCache(state: any) {
        state.expires = null;
    },

    setPartners(state: any, payload: Array<any>) {
        state.partners = payload;
        state.partnersExpire = moment().add(1, 'hour');
    },

    addPartner(state: any, payload: any) {

        const index = state.partners.findIndex((partner: RewardPartnerInterface) => partner.type === payload.type);

        if (index) {
            state.partners.splice(index, 1, payload);
        } else {
            state.partners.push(payload);
        }
    },

    enablePartner(state: any, id: any) {
        let found = state.partners.find((partner: any) => partner.id === id);

        if (found) {
            found.enabled = true;
        }
    },

    disablePartner(state: any, id: any) {
        let found = state.partners.find((partner: any) => partner.id === id);

        if (found) {
            found.enabled = false;
        }
    },

    setPayPalRewards(state: any, payload: Array<any>) {
        state.payPalRewards = payload;
    },

    setPayPalCurrencies(state: any, payload: Array<any>) {
        state.payPalCurrencies = payload;
    },

    setPayPalCurrenciesLoading(state: any, payload: boolean) {
        state.payPalCurrenciesLoading = payload;
    },

    setPayPalRewardsLoading(state: any, payload: boolean) {
        state.payPalRewardsLoading = payload;
    },

    setTangoCardRewards(state: any, payload: Array<any>) {
        state.tangoCardRewards = payload;
    },

    removeReward(state: any, id: Number) {
        let rewardPayPal = state.payPalRewards.find((reward:Reward) => {
            return reward.id === id;
        });

        if (rewardPayPal) rewardPayPal.enabled = false;

        let rewardTangoCard = state.tangoCardRewards.find((reward:Reward) => {
            return reward.id === id;
        });

        if (rewardTangoCard) rewardTangoCard.enabled = false;
    }
};
